import { render, staticRenderFns } from "./InvoiceDialog.vue?vue&type=template&id=2be978a6&scoped=true"
import script from "./InvoiceDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDialog.vue?vue&type=style&index=0&id=2be978a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be978a6",
  null
  
)

export default component.exports